import { createClient } from '@sanity/client'
const client = createClient({
  projectId: process.env.VUE_APP_SANITY_PROJECT_ID, // ENV
  dataset: process.env.VUE_APP_SANITY_DATA_SOURCE,
  useCdn: true, // `false` if you want to ensure fresh data,
  withCredentials: true
})

export default client
